
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { message } from "ant-design-vue";
import { defineComponent, onMounted, onUnmounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { getCarStatusType } from "../utils/DataConversionUtils";
import LoadingPage from "@/components/LoadingPage.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "UnattendedList",
  components: { LoadingPage },
  setup() {
    const { t } = useI18n();

    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const isLoading = ref(false);
    const router = useRouter();
    const carList = ref({
      keyWord: "",
      page: 1,
      size: 10,
      total: 0,
      is_login: "",
      has_fault: "",
    });
    const open = ref(false);
    const wakeupVin = ref("");
    const optionValue = ref();
    const onLineStatusOptions = ref([
      {
        value: "",
        label: t("whole"),
      },
      {
        value: "32",
        label: "SC50",
      },
      {
        value: "33",
        label: "SC80",
      },
      {
        value: "34",
        label: "V50",
      },
    ]);
    const dataSource = ref();
    const getListData = () => {
      const param = {
        keyword: carList.value.keyWord,
        vehicle_model: optionValue.value,
        is_login: carList.value.is_login,
        has_fault: carList.value.has_fault,
        // sort_soc: "1",
        page: carList.value.page,
        size: carList.value.size,
      };
      Api.unattendedList(param).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataSource.value = res.result;
          carList.value.total = Number(res.totalNum);
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const online_num = ref();
    const fault_vehicle_num = ref();

    const getStatisticsInfoF = () => {
      Api.getStatisticsInfo().then((val) => {
        if (val) {
          if (val?.err_no == ResultCodeType.success_200) {
            online_num.value = val.result.online_num;
            fault_vehicle_num.value = val.result.fault_vehicle_num;
          }
        }
      });
    };
    const SelectIsLogin = () => {
      carList.value.is_login = "1";
      getListData();
    };
    const SelectHasFault = () => {
      carList.value.has_fault = "1";
      getListData();
    };
    const handlePaginationChange = () => {
      getListData();
    };
    const selectChange = () => {
      carList.value.page = 1;
      getListData();
    };
    const onChange = (
      pagination: any,
      filters: any,
      sorter: any,
      extra: any
    ) => {
      console.log("params", pagination, filters, sorter, extra);
    };
    const toVehicleControl = (vin: string, status: string) => {
      router.push({
        path: routerName.vehiclecontrol,
        query: { vin: vin, status: status },
      });
    };
    let pollAwakenInterval: number;
    const awakenStatus = (vin: string) => {
      Api.awakenStatusRequest(vin).then((val: any) => {
        if (val.status == ResultCodeType.awaken_0_no_have) {
          isLoading.value = false;
          clearInterval(pollAwakenInterval);
        } else if (val.status == ResultCodeType.awaken_2_success) {
          isLoading.value = false;
          message.success(t("wakeupsuccessfully"));
        } else if (val.status == ResultCodeType.awaken_3_failt) {
          isLoading.value = false;
          message.error(t("wakeupfailed"));
        }
      });
    };
    const pollRequestAwakenStatus = (vin: string) => {
      clearInterval(pollAwakenInterval);
      pollAwakenInterval = setInterval(() => {
        awakenStatus(vin);
      }, 5 * 1000);
    };
    const toAwaken = () => {
      isLoading.value = true;
      Api.awakenRequest(wakeupVin.value)
        .then((val: any) => {
          if (val) {
            if (val?.err_no == ResultCodeType.success_200) {
              pollRequestAwakenStatus(wakeupVin.value);
            } else {
              isLoading.value = false;
              message.error(t("wakeupfailed"));
            }
          }
        })
        .catch(() => {
          isLoading.value = false;
          message.error(t("wakeupfailed"));
        })
        .finally(() => {
          open.value = false;
        });
    };
    let pollListInterval: any | undefined;
    const pollListData = () => {
      pollListInterval && clearInterval(pollListInterval);
      pollListInterval = setInterval(() => {
        getListData();
      }, 1000);
    };
    const checkedId = ref("");
    const checkItem = (value: string) => {
      checkedId.value = value;
    };

    const carTypeList = ref<Array<string>>();
    const getCarTypeList = () => {
      Api.getCarTypeList().then((res) => {
        if (res.err_no === ResultCodeType.success_200) {
          carTypeList.value = res.result;
        }
      });
    };
    const columns = [
      {
        title: t("serialnumber"),
        dataIndex: "index",
        key: "index",
        align: "center",
        fixed: "left",
        width: 150,
      },
      {
        title: "VIN",
        dataIndex: "vin",
        key: "vin",
        align: "center",
        width: 210,
      },
      {
        title: t("entryname"),
        dataIndex: "project_name",
        key: "project_name",
        align: "center",
        width: 120,
      },
      {
        title: t("vehiclemodel"),
        dataIndex: "vehicle_model",
        key: "vehicle_model",
        align: "center",
        width: 200,
      },
      {
        title: t("presence"),
        dataIndex: "sort_field",
        key: "sort_field",
        align: "center",
        width: 120,
      },
      {
        title: t("vehiclestatus"),
        dataIndex: "createTime",
        key: "createTime",
        align: "center",
        width: 120,
      },
      {
        title: t("electricitylevel") + "(%)",
        dataIndex: "electricity",
        key: "electricity",
        sorter: true,
        align: "center",
        width: 210,
      },
      {
        title: t("clearwatervolume") + "(%)",
        dataIndex: "clean_water_rate",
        key: "clean_water_rate",
        align: "center",
        width: 210,
      },
      {
        title: t("sewagevolume") + "(%)",
        dataIndex: "sewage_rate",
        key: "sewage_rate",
        align: "center",
        width: 210,
      },
      {
        title: t("speeded") + "(m/s)",
        dataIndex: "speed",
        key: "speed",
        align: "center",
        width: 120,
      },
      {
        title: t("faultstatus"),
        dataIndex: "fault_status",
        key: "fault_status",
        align: "center",
        width: 120,
      },
      {
        title: t("recentanomalies"),
        dataIndex: "exception_time",
        key: "exception_time",
        align: "center",
        width: 210,
      },
      {
        title: t("operate"),
        dataIndex: "operate_status",
        key: "operate_status",
        align: "center",
        fixed: "right",
        width: 150,
      },
    ];
    const handleOk = (id: string) => {
      open.value = true;
      wakeupVin.value = id;
    };
    onMounted(() => {
      getListData();
      getStatisticsInfoF();
      pollListData();
      getCarTypeList();
    });
    onUnmounted(() => {
      clearInterval(pollListInterval);
      pollListInterval = null;
    });
    return {
      checkItem,
      checkedId,
      carList,
      dataSource,
      columns,
      optionValue,
      onLineStatusOptions,
      fault_vehicle_num,
      online_num,
      isLoading,
      getCarStatusType,
      handlePaginationChange,
      selectChange,
      SelectIsLogin,
      SelectHasFault,
      toVehicleControl,
      toAwaken,
      onChange,
      maxHeight,
      open,
      handleOk,
      t,
      carTypeList,
    };
  },
});
